function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebsite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-94"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M685.44,125.36l5.89-9.49-2.91-1.8a2.66,2.66,0,0,1-1.23-2.5,13.25,13.25,0,0,0,0-1.67,2.67,2.67,0,0,1,1.39-2.41l3-1.61L686.36,96l-3,1.62a2.66,2.66,0,0,1-2.77-.18,15.13,15.13,0,0,0-1.42-.88,2.64,2.64,0,0,1-1.4-2.41l.1-3.42-11.16-.35-.1,3.43A2.66,2.66,0,0,1,665,96.15l-.73.37c-.25.13-.48.27-.72.41a2.63,2.63,0,0,1-2.77,0l-2.93-1.81L652,104.63l2.91,1.81a2.67,2.67,0,0,1,1.23,2.5,15.26,15.26,0,0,0-.06,1.66,2.67,2.67,0,0,1-1.38,2.41l-3,1.61,5.28,9.85,3-1.62a2.66,2.66,0,0,1,2.77.18,14.87,14.87,0,0,0,1.41.87,2.67,2.67,0,0,1,1.41,2.41l-.11,3.43,11.16.34.11-3.42a2.66,2.66,0,0,1,1.55-2.31c.25-.11.5-.24.74-.37s.48-.26.72-.41a2.65,2.65,0,0,1,2.78,0Zm-9.45-7a9.15,9.15,0,1,1,3.75-12.38A9.14,9.14,0,0,1,676,118.31Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.88,358.9,124,352.12l-2.07,1.2a1.85,1.85,0,0,1-2-.07,10.29,10.29,0,0,0-1-.58,1.86,1.86,0,0,1-1-1.66v-2.39h-7.83V351a1.86,1.86,0,0,1-1,1.66,9.12,9.12,0,0,0-1,.58,1.85,1.85,0,0,1-2,.07l-2.08-1.2-3.91,6.78,2.09,1.2a1.87,1.87,0,0,1,.91,1.72c0,.19,0,.39,0,.58s0,.38,0,.57a1.87,1.87,0,0,1-.91,1.72l-2.09,1.21,3.91,6.78,2.08-1.2a1.85,1.85,0,0,1,2,.07c.33.21.66.4,1,.58a1.85,1.85,0,0,1,1,1.65v2.4h7.83v-2.4a1.86,1.86,0,0,1,1-1.65,11,11,0,0,0,1-.58,1.85,1.85,0,0,1,2-.07l2.08,1.2,3.91-6.78-2.08-1.2a1.87,1.87,0,0,1-.91-1.72c0-.19,0-.39,0-.58s0-.39,0-.58a1.87,1.87,0,0,1,.91-1.72Zm-7.48,3.5A6.41,6.41,0,1,1,114,356,6.4,6.4,0,0,1,120.4,362.4Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.08,259.2a30.47,30.47,0,1,0,30.47,30.47A30.45,30.45,0,0,0,96.08,259.2Zm0,44.69a14.23,14.23,0,1,1,14.23-14.22A14.23,14.23,0,0,1,96.08,303.89Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.94 260.46 90.22 260.46 90.87 252.16 101.29 252.16 101.94 260.46",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.63 264.41 71.35 272.69 65.94 266.37 73.31 259 79.63 264.41",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.65 282.97 66.65 294.69 58.36 294.04 58.36 283.62 66.65 282.97",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "70.6 305.27 78.89 313.56 72.56 318.97 65.19 311.6 70.6 305.27",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "89.16 318.25 100.88 318.25 100.23 326.55 89.81 326.55 89.16 318.25",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.47 314.3 119.75 306.02 125.16 312.34 117.79 319.71 111.47 314.3",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.45 295.74 124.45 284.02 132.74 284.67 132.74 295.09 124.45 295.74",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.5 273.44 112.21 265.15 118.54 259.75 125.91 267.12 120.5 273.44",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.1,154.82a30.48,30.48,0,1,0,30.47,30.48A30.47,30.47,0,0,0,637.1,154.82Zm0,44.7a14.23,14.23,0,1,1,14.23-14.22A14.22,14.22,0,0,1,637.1,199.52Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "642.96 156.09 631.24 156.09 631.89 147.79 642.31 147.79 642.96 156.09",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "620.65 160.04 612.37 168.32 606.96 162 614.33 154.63 620.65 160.04",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "607.67 178.6 607.67 190.32 599.38 189.67 599.38 179.25 607.67 178.6",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "611.62 200.9 619.91 209.19 613.59 214.6 606.22 207.23 611.62 200.9",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "630.19 213.88 641.9 213.88 641.26 222.18 630.83 222.18 630.19 213.88",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "652.49 209.93 660.78 201.65 666.18 207.97 658.81 215.34 652.49 209.93",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "665.47 191.37 665.47 179.65 673.76 180.3 673.76 190.72 665.47 191.37",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "661.52 169.07 653.24 160.78 659.56 155.37 666.93 162.74 661.52 169.07",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-94"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.07,328.63C99.89,341.06,90.31,355.5,88,371.1c0,.23.35.31.4.07a94.22,94.22,0,0,1,4.06-12.48c6-1.67,12-3,15.14-9,3.23-6.16,2.82-14.19,2.21-20.9C109.74,328.41,109.26,328.39,109.07,328.63Z",
    style: {
      fill: "#7A679C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.54,358.57c4.12-9.26,9.42-18.55,16.15-26.17,0,0,.12,0,.07.08a110.93,110.93,0,0,0-11,17.33c3-3.09,6.37-5.85,9.25-9.12.06-.07.15,0,.09.09-2.86,3.43-6,7.16-9.71,9.7q-1.5,2.76-3,5.54c.25-.14.51-.26.77-.39a0,0,0,0,1,0,.07c-.29.14-.57.29-.86.42-.48.87-1,1.75-1.46,2.62C92.72,358.94,92.45,358.76,92.54,358.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6,355.34a53.09,53.09,0,0,0,7.05-4.71c.06-.05.15,0,.09.09a37,37,0,0,1-7,4.79C95.59,355.57,95.49,355.4,95.6,355.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.92,368.78c0,.19.34.18.33,0,0-5.13,0-10.29.08-15.45,1.32-2.66,4.14-4.13,6.11-6.26A27.71,27.71,0,0,0,97.1,342a36.64,36.64,0,0,0,4.25-14.17c.54-5.49-1.54-23.62-3.86-23-1.2.32-5.09,9.3-6.12,12.27a85.78,85.78,0,0,0-3.65,15.05C85.84,344.2,86,356.61,86.92,368.78Z",
    style: {
      fill: "#7A679C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.88,346.62l0,0c.28-6.5,1.75-13.06,3.12-19.37,1.47-6.79,3.2-13.18,6.7-19.24.06-.11.23,0,.17.1a71.31,71.31,0,0,0-5.38,14.77c.23-.36.52-.71.76-1.06.1-.13.32,0,.23.14a10.5,10.5,0,0,1-1.1,1.54l0,0c-1.2,4.85-2.07,9.82-2.81,14.77l.17-.19a0,0,0,0,1,.07.06l-.29.49c-.37,2.51-.72,5-1.06,7.51,4.47-3.83,8.29-8.34,10.45-13.89,0,0,0,0,0,0-2.11,5.76-5.44,10.88-10.57,14.38-.09.67-.18,1.34-.28,2,0,.14-.24.1-.24,0,0-.59,0-1.18.06-1.77C86.83,346.78,86.8,346.68,86.88,346.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89,337.2a104.05,104.05,0,0,0,9.12-15.7c0-.06.13,0,.11.05a51.08,51.08,0,0,1-9.06,15.78C89.08,337.43,88.92,337.31,89,337.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.53,320.24c1.42-2.51,2.91-4.95,4.25-7.51,0-.07.13,0,.1.07a38.77,38.77,0,0,1-4.13,7.56C93.66,320.49,93.45,320.38,93.53,320.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93,321.33a0,0,0,1,1,0,0A0,0,0,1,1,93,321.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.44,353.92A52.79,52.79,0,0,1,82.24,364c.05.37.1.73.16,1.11a48.63,48.63,0,0,0,1.81-11.28.34.34,0,0,0,0-.35h0a74,74,0,0,0-1.13-15.28c-1.59-9.44-5.07-18.5-11.65-25.58a.48.48,0,0,0-.73.15c-2.65,6.76-1.73,14.82.54,21.56a39.38,39.38,0,0,0,5.22,10.23C78.73,347.77,81.61,350.46,83.44,353.92Z",
    style: {
      fill: "#7A679C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.22,315.81c6.24,10.13,10.58,22.14,11.11,34.1,0,.21-.35.27-.38,0-.14-1.08-.31-2.14-.48-3.2h0a40.86,40.86,0,0,1-7.08-8.17c0-.05.05-.11.09-.06A86.85,86.85,0,0,0,82.34,346q-.66-4-1.6-7.81c-.17-.19-.33-.39-.49-.58s.07-.31.18-.19l.15.17a89.51,89.51,0,0,0-3.26-10.36c-1.59-1.89-3.36-3.53-4.52-5.81a0,0,0,0,1,.08-.05c.93,1.3,1.83,2.62,2.89,3.83.42.48.88.93,1.32,1.4A80.3,80.3,0,0,0,72,316C71.89,315.8,72.13,315.66,72.22,315.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.48,328.31c2,2.71,4.32,5.3,6.19,8.1a.08.08,0,0,1-.13.1,41.13,41.13,0,0,1-6.19-8.12C73.29,328.3,73.42,328.23,73.48,328.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,337l.09.09a.06.06,0,0,1-.09.09l-.09-.08C79.8,337.08,79.89,337,80,337Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.44,335.28A31.21,31.21,0,0,0,69,350.73a16.42,16.42,0,0,0,5.34,4.16c2.31,1.15,4.73,2.46,7.12,3.4a46.88,46.88,0,0,1,2.53,9c.07-.27.15-.54.23-.8-1.54-13.19-10.07-24.46-21-31.7A.54.54,0,0,0,62.44,335.28Z",
    style: {
      fill: "#7A679C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.22,339.18c-.08-.07,0-.21.11-.15a44.73,44.73,0,0,1,13.91,17.15c.08.18-.17.34-.27.16-.51-.89-1-1.76-1.55-2.61h0c-2.49-.47-4.85-2.22-6.7-3.88a.05.05,0,0,1,.07-.08A15.71,15.71,0,0,0,74.93,352c1,.51,2.11.84,3.17,1.25-.92-1.47-1.89-2.87-2.89-4.23a29.21,29.21,0,0,1-7.49-4.21c-.07-.06,0-.17.07-.12a77.62,77.62,0,0,0,7,3.72,60.4,60.4,0,0,0-4.91-5.73c-.85-.45-1.71-.9-2.53-1.38a.07.07,0,0,1,0-.13,8.75,8.75,0,0,1,1.94,1C68.32,341.12,67.3,340.14,66.22,339.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.45,343.73a3.19,3.19,0,0,1,.42.3,0,0,0,0,1-.05.07,2.38,2.38,0,0,1-.44-.25A.07.07,0,1,1,66.45,343.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.28 395.82 71.37 395.82 73.78 368.57 74.31 362.57 98.34 362.57 98.87 368.57 101.28 395.82",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.87 368.57 73.78 368.57 74.31 362.57 98.34 362.57 98.87 368.57",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.88,
    y: 358.37,
    width: 26.89,
    height: 5.95,
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-94"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "56.76 395.82 136.32 395.57 215.88 395.49 375 395.32 534.12 395.49 613.68 395.57 693.24 395.82 613.68 396.06 534.12 396.15 375 396.32 215.88 396.15 136.32 396.06 56.76 395.82",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-94"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 154.28,
    y: 96.15,
    width: 441.45,
    height: 295.29,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.49,
    y: 99.75,
    width: 435.03,
    height: 288.09,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.78,
    y: 413.59,
    width: 556.44,
    height: 20.27,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.78 413.59 154.28 391.44 595.72 391.44 653.22 413.59 96.78 413.59",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.41 405.73 196.51 391.44 553.49 391.44 590.59 405.73 159.41 405.73",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.74,
    y: 121.53,
    width: 386.51,
    height: 244.52,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.74,
    y: 121.53,
    width: 386.51,
    height: 9.41,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.22,126.24a2.33,2.33,0,1,1-2.33-2.33A2.33,2.33,0,0,1,189.22,126.24Z",
    style: {
      fill: "#7A679C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.75,126.24a2.34,2.34,0,1,1-2.33-2.33A2.33,2.33,0,0,1,198.75,126.24Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.28,126.24a2.34,2.34,0,1,1-2.33-2.33A2.33,2.33,0,0,1,208.28,126.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.57,
    y: 236.19,
    width: 70.42,
    height: 54.03,
    transform: "translate(803.56 526.41) rotate(180)",
    style: {
      fill: "#7A679C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.58,248a6.39,6.39,0,1,0,5-5A6.4,6.4,0,0,0,373.58,248Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.8 278.58 436.99 278.58 413.4 249.5 389.8 278.58",
    style: {
      fill: "#7A679C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.8 278.58 436.99 278.58 413.4 249.5 389.8 278.58",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.57 278.61 408.42 278.61 387.49 259.67 366.57 278.61",
    style: {
      fill: "#7A679C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.57 278.61 408.42 278.61 387.49 259.67 366.57 278.61",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.57,
    y: 278.58,
    width: 70.42,
    height: 11.64,
    style: {
      fill: "#7A679C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.57,
    y: 278.58,
    width: 70.42,
    height: 11.64,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.83,
    y: 236.19,
    width: 52.9,
    height: 4.45,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.83,
    y: 246.51,
    width: 153.08,
    height: 4.45,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.83,
    y: 256.31,
    width: 153.08,
    height: 4.45,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.83,
    y: 266.1,
    width: 153.08,
    height: 4.45,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.83,
    y: 275.89,
    width: 153.08,
    height: 4.45,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.83,
    y: 285.68,
    width: 153.08,
    height: 4.45,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.32,
    y: 148.82,
    width: 52.9,
    height: 11.91,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.32,
    y: 168.94,
    width: 108.68,
    height: 4.45,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.32,
    y: 178.73,
    width: 108.68,
    height: 4.45,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.32,
    y: 188.52,
    width: 108.68,
    height: 4.45,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.32,
    y: 198.31,
    width: 108.68,
    height: 4.45,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.32,
    y: 211.34,
    width: 108.68,
    height: 4.45,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.32,
    y: 221.13,
    width: 108.68,
    height: 4.45,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.42,
    y: 148.82,
    width: 96.73,
    height: 12.12,
    style: {
      fill: "#7A679C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.69,
    y: 160.94,
    width: 96.22,
    height: 129.06,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.17,290.22H452.42V160.73h96.75ZM453,289.79h95.68V161.16H453Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "452.94 290.09 452.44 289.93 548.65 160.86 549.15 161.02 452.94 290.09",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "548.65 290.09 452.44 161.02 452.94 160.86 549.15 289.93 548.65 290.09",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.03,
    y: 149.03,
    width: 115.28,
    height: 76.34,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.85,225.58v-.19l0-76.53H201l115.48,0,0,76.73h-.19Zm.37-76.34,0,75.95,114.9,0,0-75.95Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.22,149.24c9.69,6.15,19.33,12.39,28.95,18.64L259,186.76l28.66,19.08,14.28,9.61,14.23,9.71-14.51-9.27-14.45-9.36-28.8-18.88-28.66-19.08C220.19,162.17,210.67,155.76,201.22,149.24Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.14,149.24c-9.46,6.52-19,12.93-28.51,19.33L259,187.65l-28.8,18.88-14.44,9.36-14.51,9.27,14.22-9.71,14.28-9.61,28.66-19.08,28.8-18.88C296.8,161.63,306.44,155.39,316.14,149.24Z",
    style: {
      fill: "#dbdbdb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screens--inject-94"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 533.85,
    y: 60.55,
    width: 93.64,
    height: 59.73,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.08,120.87H533.25V60h94.83Zm-93.64-1.18h92.45V61.14H534.44Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 533.85,
    y: 60.55,
    width: 93.64,
    height: 11.3,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.45,66.28a2.85,2.85,0,1,1-2.84-2.85A2.84,2.84,0,0,1,544.45,66.28Z",
    style: {
      fill: "#7A679C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.06,66.28a2.85,2.85,0,1,1-2.84-2.85A2.84,2.84,0,0,1,556.06,66.28Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.67,66.28a2.85,2.85,0,1,1-2.84-2.85A2.84,2.84,0,0,1,567.67,66.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550,94.18a11.55,11.55,0,0,1,11.54-11.33,11.78,11.78,0,0,1,7.27,2.46,1.8,1.8,0,0,1-2.2,2.86,7.88,7.88,0,0,0-5.07-1.73,8.34,8.34,0,0,0-5.66,2.26,7.76,7.76,0,0,0-2.3,5.48,7.62,7.62,0,0,0,2.3,5.47,8.3,8.3,0,0,0,5.66,2.27,7.94,7.94,0,0,0,5.07-1.73,1.91,1.91,0,0,1,2.52.34,1.86,1.86,0,0,1-.32,2.52,11.78,11.78,0,0,1-7.27,2.46A11.51,11.51,0,0,1,550,94.18Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.55,100a1.63,1.63,0,0,1,2.29-.22,10.25,10.25,0,0,0,6,2.42,6.78,6.78,0,0,0,3.93-1.16,2.83,2.83,0,0,0,1.36-2.27,1.78,1.78,0,0,0-.29-1,2.89,2.89,0,0,0-.94-1,12.79,12.79,0,0,0-4.31-1.48h-.06a17.08,17.08,0,0,1-4.06-1.22,6.79,6.79,0,0,1-2.93-2.46,4.82,4.82,0,0,1-.72-2.58,5.81,5.81,0,0,1,2.52-4.59,9.26,9.26,0,0,1,5.44-1.67,12.33,12.33,0,0,1,6.86,2.52,1.62,1.62,0,0,1,.44,2.23,1.6,1.6,0,0,1-2.24.48c-1.6-1.07-3.14-2-5.06-2a6,6,0,0,0-3.53,1.07,2.52,2.52,0,0,0-1.19,2,1.5,1.5,0,0,0,.22.88,2.91,2.91,0,0,0,.85.82,10.85,10.85,0,0,0,3.93,1.39h.06a18.21,18.21,0,0,1,4.35,1.32,7.34,7.34,0,0,1,3.14,2.61,5,5,0,0,1,.76,2.67,6.07,6.07,0,0,1-2.71,4.88,9.84,9.84,0,0,1-5.82,1.79,13.56,13.56,0,0,1-8.05-3.14A1.68,1.68,0,0,1,574.55,100Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.22,100a1.63,1.63,0,0,1,2.29-.22,10.25,10.25,0,0,0,6,2.42,6.78,6.78,0,0,0,3.93-1.16,2.83,2.83,0,0,0,1.36-2.27,1.78,1.78,0,0,0-.29-1,2.89,2.89,0,0,0-.94-1,12.79,12.79,0,0,0-4.31-1.48h-.06a17.08,17.08,0,0,1-4.06-1.22,6.79,6.79,0,0,1-2.93-2.46,4.82,4.82,0,0,1-.72-2.58A5.81,5.81,0,0,1,598,84.52a9.26,9.26,0,0,1,5.44-1.67,12.33,12.33,0,0,1,6.86,2.52,1.62,1.62,0,0,1,.44,2.23,1.6,1.6,0,0,1-2.24.48c-1.6-1.07-3.14-2-5.06-2a6,6,0,0,0-3.53,1.07,2.52,2.52,0,0,0-1.19,2A1.5,1.5,0,0,0,599,90a2.91,2.91,0,0,0,.85.82,10.85,10.85,0,0,0,3.93,1.39h.06a18.21,18.21,0,0,1,4.35,1.32,7.34,7.34,0,0,1,3.14,2.61,5.14,5.14,0,0,1,.76,2.67,6.07,6.07,0,0,1-2.71,4.88,9.84,9.84,0,0,1-5.82,1.79,13.56,13.56,0,0,1-8-3.14A1.68,1.68,0,0,1,595.22,100Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589.65,
    y: 142.82,
    width: 52.57,
    height: 23.62,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.29,155.68h-2.18v3.85a1,1,0,0,1-2,0V149.05a1,1,0,0,1,1-1h3.17a3.8,3.8,0,1,1,0,7.6Zm-2.18-2h2.18a1.83,1.83,0,1,0,0-3.66h-2.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.49,159.53V149.05a1,1,0,0,1,1-1,1,1,0,0,1,1,1v4.27h4.6v-4.27a1,1,0,0,1,1-1,1,1,0,0,1,1,1v10.48a1,1,0,0,1-1,1,1,1,0,0,1-1-1v-4.26h-4.6v4.26a1,1,0,0,1-1,1A1,1,0,0,1,611.49,159.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.23,155.68h-2.18v3.85a1,1,0,0,1-1,1,1,1,0,0,1-1-1V149.05a1,1,0,0,1,1-1h3.18a3.8,3.8,0,1,1,0,7.6Zm-2.18-2h2.18a1.83,1.83,0,1,0,0-3.66h-2.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 398.47,
    y: 247.83,
    width: 156.16,
    height: 109.4,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.23,357.83H397.88V247.24H555.23Zm-156.16-1.18h155V248.43h-155Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.47,
    y: 247.83,
    width: 156.16,
    height: 11.3,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.23,259.72H397.88V247.24H555.23Zm-156.16-1.18h155V248.43h-155Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.08,253.56a2.85,2.85,0,1,1-2.85-2.84A2.86,2.86,0,0,1,409.08,253.56Z",
    style: {
      fill: "#7A679C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.69,253.56a2.85,2.85,0,1,1-2.85-2.84A2.86,2.86,0,0,1,420.69,253.56Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.3,253.56a2.85,2.85,0,1,1-2.85-2.84A2.86,2.86,0,0,1,432.3,253.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.59,
    y: 281.6,
    width: 6.04,
    height: 2.21,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.03,
    y: 281.6,
    width: 69.28,
    height: 2.21,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 494.02,
    y: 281.6,
    width: 11.47,
    height: 2.21,
    style: {
      fill: "#7A679C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 507.99,
    y: 281.6,
    width: 19.83,
    height: 2.21,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.63,
    y: 287.51,
    width: 6.04,
    height: 2.21,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426.92,
    y: 287.51,
    width: 45.46,
    height: 2.21,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.03,
    y: 305.22,
    width: 43.42,
    height: 2.21,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426.92,
    y: 293.41,
    width: 30.46,
    height: 2.21,
    style: {
      fill: "#7A679C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 501.69,
    y: 299.31,
    width: 11.62,
    height: 2.21,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 460.77,
    y: 293.41,
    width: 48.65,
    height: 2.21,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.03,
    y: 311.12,
    width: 58.07,
    height: 2.21,
    style: {
      fill: "#7A679C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.71,
    y: 287.51,
    width: 31.47,
    height: 2.21,
    style: {
      fill: "#7A679C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 475.24,
    y: 287.51,
    width: 28.97,
    height: 2.21,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 511.7,
    y: 293.41,
    width: 19.55,
    height: 2.21,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.63,
    y: 293.41,
    width: 6.04,
    height: 2.21,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.59,
    y: 299.31,
    width: 6.04,
    height: 2.21,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.03,
    y: 299.31,
    width: 35.69,
    height: 2.21,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.92,
    y: 305.22,
    width: 38.58,
    height: 2.21,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 507.99,
    y: 305.22,
    width: 24.55,
    height: 2.21,
    style: {
      fill: "#7A679C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 460.35,
    y: 299.31,
    width: 38.53,
    height: 2.21,
    style: {
      fill: "#7A679C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.59,
    y: 305.22,
    width: 6.04,
    height: 2.21,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.59,
    y: 311.12,
    width: 6.04,
    height: 2.21,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.32,275.79a.53.53,0,0,1,0,.75.51.51,0,0,1-.36.15.54.54,0,0,1-.38-.15l-2.33-2.36a.05.05,0,0,1,0-.05l0,0a.1.1,0,0,1,0-.07l0,0s0,0,0-.05,0,0,0,0v-.06s0,0,0-.05v-.1s0,0,0,0l0-.07s0,0,0,0,0,0,0-.07a0,0,0,0,1,0,0s0,0,.05-.05l2.33-2.37a.53.53,0,0,1,.74,0,.53.53,0,0,1,0,.75l-2,2Z",
    style: {
      fill: "#7A679C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.43,276.06l2-4.84a.45.45,0,1,1,.83.35l-2,4.84a.45.45,0,0,1-.42.28.35.35,0,0,1-.17,0A.44.44,0,0,1,416.43,276.06Z",
    style: {
      fill: "#7A679C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.31,274.11h0l-.05.06-2.33,2.36a.54.54,0,0,1-.38.15.53.53,0,0,1-.37-.15.53.53,0,0,1,0-.75l2-2-2-2a.53.53,0,0,1,0-.75.54.54,0,0,1,.75,0l2.33,2.37.05.05s0,0,0,0,0,.05,0,.07,0,0,0,0a.41.41,0,0,0,0,.08s0,0,0,0v.21h0s0,.06,0,.08v0A.2.2,0,0,1,423.31,274.11Z",
    style: {
      fill: "#7A679C"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 148.39,
    y: 252.23,
    width: 63.79,
    height: 23.62,
    style: {
      fill: "#7A679C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.59,268.94V258.46a1,1,0,0,1,2,0v4.27h4.6v-4.27a1,1,0,0,1,2,0v10.48a1,1,0,0,1-2,0v-4.26h-4.6v4.26a1,1,0,0,1-2,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.78,259.46H175v9.48a1,1,0,0,1-1,1,1,1,0,0,1-1-1v-9.48h-2.8a1,1,0,0,1-1-1,1,1,0,0,1,1-1h7.58a1,1,0,0,1,1,1A1,1,0,0,1,177.78,259.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.37,258.46v10.48a1,1,0,0,1-1,1,1,1,0,0,1-1-1v-7.47L187.84,265a1,1,0,0,1-.8.4h0a1,1,0,0,1-.82-.4l-2.54-3.55v7.47a1,1,0,0,1-2,0V258.46a1,1,0,0,1,1-1h.05a1,1,0,0,1,.78.41l3.54,4.9,3.53-4.9a1,1,0,0,1,.8-.41h0A1,1,0,0,1,192.37,258.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.67,268.94V258.46a1,1,0,0,1,1-1,1,1,0,0,1,1,1V268h4.81a1,1,0,0,1,0,2h-5.81A1,1,0,0,1,196.67,268.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 622.66,
    y: 224.38,
    width: 35.61,
    height: 23.62,
    style: {
      fill: "#7A679C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.33,238.48a2.37,2.37,0,0,0,4.62-.73v-6.82a1,1,0,0,1,1.91,0v6.82a4.27,4.27,0,0,1-8.34,1.31.93.93,0,0,1,.61-1.19A.94.94,0,0,1,632.33,238.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.26,239a.89.89,0,0,1,1.25-.12,5.67,5.67,0,0,0,3.29,1.32,3.71,3.71,0,0,0,2.15-.64,1.54,1.54,0,0,0,.74-1.23.92.92,0,0,0-.16-.55,1.56,1.56,0,0,0-.51-.52,6.9,6.9,0,0,0-2.36-.81h0a9,9,0,0,1-2.22-.67,3.69,3.69,0,0,1-1.6-1.34,2.61,2.61,0,0,1-.4-1.41,3.18,3.18,0,0,1,1.38-2.51,5.05,5.05,0,0,1,3-.91,6.78,6.78,0,0,1,3.75,1.37.88.88,0,0,1,.24,1.22.86.86,0,0,1-1.22.26,5,5,0,0,0-2.77-1.1,3.22,3.22,0,0,0-1.92.59,1.35,1.35,0,0,0-.66,1.08.8.8,0,0,0,.13.48,1.64,1.64,0,0,0,.46.45,5.9,5.9,0,0,0,2.15.75h0a10.39,10.39,0,0,1,2.38.73,4.08,4.08,0,0,1,1.72,1.42,2.89,2.89,0,0,1,.41,1.47A3.32,3.32,0,0,1,649,241a5.36,5.36,0,0,1-3.18,1,7.38,7.38,0,0,1-4.4-1.72A.91.91,0,0,1,641.26,239Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 84.34,
    width: 93.64,
    height: 59.73,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.23,144.67H80.41V83.75h94.82Zm-93.64-1.19h92.46V84.94H81.59Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 84.34,
    width: 93.64,
    height: 11.3,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.23,96.23H80.41V83.75h94.82ZM81.59,95.05h92.46V84.94H81.59Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6,90.07a2.84,2.84,0,1,1-2.84-2.84A2.84,2.84,0,0,1,91.6,90.07Z",
    style: {
      fill: "#7A679C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.21,90.07a2.84,2.84,0,1,1-2.84-2.84A2.84,2.84,0,0,1,103.21,90.07Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.82,90.07A2.85,2.85,0,1,1,112,87.23,2.84,2.84,0,0,1,114.82,90.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.48,118A11.56,11.56,0,0,1,110,106.65a11.8,11.8,0,0,1,7.27,2.45,1.81,1.81,0,0,1-2.21,2.87,7.78,7.78,0,0,0-5.06-1.73,8.32,8.32,0,0,0-5.66,2.26,7.76,7.76,0,0,0-2.3,5.48,7.62,7.62,0,0,0,2.3,5.47,8.28,8.28,0,0,0,5.66,2.27,7.89,7.89,0,0,0,5.06-1.73,1.91,1.91,0,0,1,2.52.34,1.86,1.86,0,0,1-.31,2.52A11.8,11.8,0,0,1,110,129.3,11.51,11.51,0,0,1,98.48,118Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.65,120h-4.47a1.73,1.73,0,0,1,0-3.46h4.47v-4.38a1.8,1.8,0,0,1,3.59,0v4.38h4.47a1.73,1.73,0,0,1,0,3.46h-4.47v4.37a1.8,1.8,0,1,1-3.59,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.16,120h-4.47a1.73,1.73,0,1,1,0-3.46h4.47v-4.38a1.77,1.77,0,0,1,1.79-1.79,1.79,1.79,0,0,1,1.79,1.79v4.38h4.47a1.73,1.73,0,0,1,0,3.46h-4.47v4.37a1.79,1.79,0,0,1-1.79,1.8,1.77,1.77,0,0,1-1.79-1.8Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Crane--inject-94"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 124.41,
    y: 200.32,
    width: 22.36,
    height: 2.18,
    transform: "translate(-103.97 161.88) rotate(-46.68)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.92,
    y: 209.14,
    width: 15.71,
    height: 2.18,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.92,
    y: 192.18,
    width: 15.71,
    height: 2.18,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.5,
    y: 190.23,
    width: 2.18,
    height: 22.36,
    transform: "translate(-101.23 147.85) rotate(-43.31)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.41,
    y: 217.27,
    width: 22.36,
    height: 2.18,
    transform: "translate(-116.3 167.19) rotate(-46.68)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.92,
    y: 226.09,
    width: 15.71,
    height: 2.18,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.92,
    y: 209.14,
    width: 15.71,
    height: 2.18,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.5,
    y: 207.18,
    width: 2.18,
    height: 22.36,
    transform: "translate(-112.85 152.46) rotate(-43.31)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.41,
    y: 234.23,
    width: 22.36,
    height: 2.18,
    transform: "translate(-128.64 172.52) rotate(-46.68)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.92,
    y: 243.05,
    width: 15.71,
    height: 2.18,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.92,
    y: 226.09,
    width: 15.71,
    height: 2.18,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.5,
    y: 224.14,
    width: 2.18,
    height: 22.36,
    transform: "translate(-124.48 157.08) rotate(-43.31)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.41,
    y: 251.18,
    width: 22.36,
    height: 2.18,
    transform: "translate(-140.97 177.84) rotate(-46.68)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.92,
    y: 260,
    width: 15.71,
    height: 2.18,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.92,
    y: 243.05,
    width: 15.71,
    height: 2.18,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.5,
    y: 241.09,
    width: 2.18,
    height: 22.36,
    transform: "translate(-136.11 161.69) rotate(-43.31)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.41,
    y: 268.14,
    width: 22.36,
    height: 2.18,
    transform: "translate(-153.31 183.17) rotate(-46.68)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.92,
    y: 276.95,
    width: 15.71,
    height: 2.18,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.92,
    y: 260,
    width: 15.71,
    height: 2.18,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.5,
    y: 258.04,
    width: 2.18,
    height: 22.36,
    transform: "translate(-147.74 166.31) rotate(-43.31)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.41,
    y: 285.09,
    width: 22.36,
    height: 2.18,
    transform: "matrix(0.69, -0.73, 0.73, 0.69, -165.64, 188.49)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.92,
    y: 293.91,
    width: 15.71,
    height: 2.18,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.92,
    y: 276.95,
    width: 15.71,
    height: 2.18,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.5,
    y: 275,
    width: 2.18,
    height: 22.36,
    transform: "translate(-159.37 170.93) rotate(-43.31)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.41,
    y: 302.04,
    width: 22.36,
    height: 2.18,
    transform: "matrix(0.69, -0.73, 0.73, 0.69, -177.98, 193.81)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.92,
    y: 310.86,
    width: 15.71,
    height: 2.18,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.92,
    y: 293.91,
    width: 15.71,
    height: 2.18,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.5,
    y: 291.95,
    width: 2.18,
    height: 22.36,
    transform: "translate(-171 175.54) rotate(-43.31)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.41,
    y: 319,
    width: 22.36,
    height: 2.18,
    transform: "translate(-190.31 199.13) rotate(-46.68)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.92,
    y: 327.81,
    width: 15.71,
    height: 2.18,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.92,
    y: 310.86,
    width: 15.71,
    height: 2.18,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.5,
    y: 308.91,
    width: 2.18,
    height: 22.36,
    transform: "translate(-182.63 180.16) rotate(-43.31)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.41,
    y: 335.95,
    width: 22.36,
    height: 2.18,
    transform: "translate(-202.64 204.44) rotate(-46.68)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.92,
    y: 344.77,
    width: 15.71,
    height: 2.18,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.92,
    y: 327.81,
    width: 15.71,
    height: 2.18,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.5,
    y: 325.86,
    width: 2.18,
    height: 22.36,
    transform: "translate(-194.25 184.78) rotate(-43.31)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.41,
    y: 352.91,
    width: 22.36,
    height: 2.18,
    transform: "translate(-215.03 209.9) rotate(-46.7)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.92,
    y: 361.72,
    width: 15.71,
    height: 2.18,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.92,
    y: 344.77,
    width: 15.71,
    height: 2.18,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.5,
    y: 342.81,
    width: 2.18,
    height: 22.36,
    transform: "translate(-205.89 189.4) rotate(-43.31)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.41,
    y: 369.86,
    width: 22.36,
    height: 2.18,
    transform: "translate(-227.37 215.23) rotate(-46.7)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.92,
    y: 378.68,
    width: 15.71,
    height: 2.18,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.92,
    y: 361.72,
    width: 15.71,
    height: 2.18,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.5,
    y: 359.77,
    width: 2.18,
    height: 22.36,
    transform: "translate(-217.51 194.01) rotate(-43.31)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.51,
    y: 372.05,
    width: 9.87,
    height: 22.66,
    transform: "translate(518.83 247.94) rotate(90)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.96,
    y: 283.23,
    width: 186,
    height: 5.68,
    transform: "translate(413.02 159.12) rotate(90)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.94,
    y: 283.23,
    width: 186,
    height: 5.68,
    transform: "translate(430.01 142.13) rotate(90)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.07 191.74 279.09 175.01 135.8 148.31 92.25 175.14 91.11 173.28 135.37 146.01 280.15 172.99 297.6 190.19 296.07 191.74",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "153.08 177.36 135.63 153.1 118.92 177.32 115.33 174.85 135.55 145.54 156.62 174.81 153.08 177.36",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.41,
    y: 174.22,
    width: 2.18,
    height: 22.36,
    transform: "translate(-49.95 255.07) rotate(-46.69)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.22,
    y: 177.36,
    width: 2.18,
    height: 15.71,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.27,
    y: 177.36,
    width: 2.18,
    height: 15.71,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.31,
    y: 184.31,
    width: 22.36,
    height: 2.18,
    transform: "translate(-53.5 236.08) rotate(-43.32)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.45,
    y: 174.22,
    width: 2.18,
    height: 22.36,
    transform: "translate(-55.28 242.73) rotate(-46.69)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.27,
    y: 177.36,
    width: 2.18,
    height: 15.71,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.32,
    y: 177.36,
    width: 2.18,
    height: 15.71,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.36,
    y: 184.31,
    width: 22.36,
    height: 2.18,
    transform: "translate(-58.12 224.45) rotate(-43.32)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.5,
    y: 174.22,
    width: 2.18,
    height: 22.36,
    transform: "translate(-60.6 230.4) rotate(-46.69)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.32,
    y: 177.36,
    width: 2.18,
    height: 15.71,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.36,
    y: 177.36,
    width: 2.18,
    height: 15.71,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.41,
    y: 184.31,
    width: 22.36,
    height: 2.18,
    transform: "translate(-62.74 212.82) rotate(-43.32)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.55,
    y: 174.22,
    width: 2.18,
    height: 22.36,
    transform: "translate(-65.93 218.06) rotate(-46.69)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.36,
    y: 177.36,
    width: 2.18,
    height: 15.71,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.41,
    y: 177.36,
    width: 2.18,
    height: 15.71,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.45,
    y: 184.31,
    width: 22.36,
    height: 2.18,
    transform: "translate(-67.36 201.19) rotate(-43.32)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.59,
    y: 174.22,
    width: 2.18,
    height: 22.36,
    transform: "translate(-71.25 205.72) rotate(-46.69)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.41,
    y: 177.36,
    width: 2.18,
    height: 15.71,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.45,
    y: 177.36,
    width: 2.18,
    height: 15.71,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.5,
    y: 184.31,
    width: 22.36,
    height: 2.18,
    transform: "translate(-71.98 189.56) rotate(-43.32)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.64,
    y: 174.22,
    width: 2.18,
    height: 22.36,
    transform: "translate(-76.58 193.39) rotate(-46.69)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.45,
    y: 177.36,
    width: 2.18,
    height: 15.71,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.5,
    y: 177.36,
    width: 2.18,
    height: 15.71,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.55,
    y: 184.31,
    width: 22.36,
    height: 2.18,
    transform: "translate(-76.59 177.92) rotate(-43.32)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.68,
    y: 174.22,
    width: 2.18,
    height: 22.36,
    transform: "translate(-81.91 181.05) rotate(-46.69)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.5,
    y: 177.36,
    width: 2.18,
    height: 15.71,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.55,
    y: 177.36,
    width: 2.18,
    height: 15.71,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.59,
    y: 184.31,
    width: 22.36,
    height: 2.18,
    transform: "translate(-81.21 166.3) rotate(-43.32)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.73,
    y: 174.22,
    width: 2.18,
    height: 22.36,
    transform: "translate(-87.23 168.71) rotate(-46.69)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.55,
    y: 177.36,
    width: 2.18,
    height: 15.71,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.59,
    y: 177.36,
    width: 2.18,
    height: 15.71,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.64,
    y: 184.31,
    width: 22.36,
    height: 2.18,
    transform: "translate(-85.83 154.66) rotate(-43.32)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.78,
    y: 174.22,
    width: 2.18,
    height: 22.36,
    transform: "translate(-92.56 156.37) rotate(-46.69)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.59,
    y: 177.36,
    width: 2.18,
    height: 15.71,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.64,
    y: 177.36,
    width: 2.18,
    height: 15.71,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.68,
    y: 184.31,
    width: 22.36,
    height: 2.18,
    transform: "translate(-90.45 143.03) rotate(-43.32)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.82,
    y: 174.22,
    width: 2.18,
    height: 22.36,
    transform: "translate(-97.88 144.04) rotate(-46.69)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.64,
    y: 177.36,
    width: 2.18,
    height: 15.71,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.69,
    y: 177.36,
    width: 2.18,
    height: 15.71,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.73,
    y: 184.31,
    width: 22.36,
    height: 2.18,
    transform: "translate(-95.07 131.4) rotate(-43.32)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.87,
    y: 174.22,
    width: 2.18,
    height: 22.36,
    transform: "translate(-103.21 131.7) rotate(-46.69)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.69,
    y: 177.36,
    width: 2.18,
    height: 15.71,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.73,
    y: 177.36,
    width: 2.18,
    height: 15.71,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.78,
    y: 184.31,
    width: 22.36,
    height: 2.18,
    transform: "translate(-99.69 119.78) rotate(-43.32)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.23,
    y: 173.25,
    width: 9.86,
    height: 22.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.09,
    y: 173.25,
    width: 9.87,
    height: 22.66,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.07,
    y: 195.91,
    width: 18.93,
    height: 11.3,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.09,
    y: 190.23,
    width: 206.51,
    height: 5.68,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.82 178.93 91.09 178.93 91.09 173.25 280.27 173.25 285.82 178.93",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.94,
    y: 177.36,
    width: 2.18,
    height: 15.71,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.44,295.67c1.31-1.82,2.71-3.58,4.11-5.32s2.85-3.45,4.31-5.14l.39-.46.37.47c2.16,2.69,4.31,5.38,6.4,8.12l3.14,4.12c1,1.4,2,2.77,3,4.18-1.17-1.27-2.29-2.58-3.43-3.87l-3.36-3.94c-2.23-2.63-4.4-5.3-6.56-8l.76,0c-1.48,1.68-2.95,3.36-4.49,5S252.06,294.11,250.44,295.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.71,
    y: 198.23,
    width: 2.18,
    height: 68.08,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.15,
    y: 198.95,
    width: 2.18,
    height: 68.08,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.8,
    y: 195.91,
    width: 28.73,
    height: 4.63,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.26,271.72l-.24,4.83-.7-.83a7.55,7.55,0,0,1,2.19.94,5.2,5.2,0,0,1,1.73,1.7,4.3,4.3,0,0,1-.12,4.59,4.49,4.49,0,0,1-3.88,2,4.72,4.72,0,0,1-3.61-2.16,4.49,4.49,0,0,0,3.6,1.73,3.88,3.88,0,0,0,3.17-2,3.26,3.26,0,0,0-.22-3.46,5.1,5.1,0,0,0-3.16-1.68l-.66-.1,0-.73-.24-4.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.53 261.8 273.53 269.69 259.17 273.1 244.81 269.69 244.81 261.8 273.53 261.8",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.39,266.43a1.67,1.67,0,1,1-1.66-1.67A1.66,1.66,0,0,1,251.39,266.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.28,266.43a1.67,1.67,0,1,1-1.67-1.67A1.67,1.67,0,0,1,270.28,266.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.27,147.16a3.68,3.68,0,1,1-3.68-3.67A3.68,3.68,0,0,1,139.27,147.16Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.31,147.16a1.72,1.72,0,1,1-1.72-1.72A1.72,1.72,0,0,1,137.31,147.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.58,
    y: 388.32,
    width: 31.73,
    height: 7.5,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.71,
    y: 395.82,
    width: 45.48,
    height: 14.71,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.9,209h-34V171.44h22.18a7.76,7.76,0,0,1,7.68,6.73Z",
    style: {
      fill: "#7A679C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.66,197.6H128.74a1.7,1.7,0,0,1-.51-.07,1.81,1.81,0,0,1-1.28-1.72V175.73h11.32a5.44,5.44,0,0,1,1.14.11,6.24,6.24,0,0,1,2.37.94,6.31,6.31,0,0,1,1.32,1.2,6.39,6.39,0,0,1,1.43,3.23l1.9,14.36A1.79,1.79,0,0,1,144.66,197.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143,187.12a1.8,1.8,0,0,1-.53,1.27l-9.21,9.21h-4.47a1.7,1.7,0,0,1-.51-.07l11.67-11.67a1.79,1.79,0,0,1,3,1.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.1,178,127,194.13v-2.52l14.83-14.83A6.31,6.31,0,0,1,143.1,178Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.41,175.84,130.23,185a1.34,1.34,0,0,1-1.89-1.89l7.4-7.39h2.53A5.44,5.44,0,0,1,139.41,175.84Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 208.14,
    y: 298.33,
    width: 95.24,
    height: 63.06,
    transform: "translate(102.54 -58.4) rotate(16.25)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201,346.91l0-.15,17.69-60.7.16.05,91.58,26.7-17.74,60.85-.15-.05Zm18-60.45L201.42,346.7l91.12,26.56L310.11,313Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.14,332.89a10.81,10.81,0,1,1-7.35-13.41A10.81,10.81,0,0,1,266.14,332.89Z",
    style: {
      fill: "#7A679C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.1 332.97 252.66 324.2 262.36 331.78 250.1 332.97",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.01,
    y: 355.31,
    width: 95.24,
    height: 4.93,
    transform: "translate(110.03 -55.01) rotate(16.25)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.85,
    y: 356.54,
    width: 80.16,
    height: 1.46,
    transform: "translate(109.82 -54.55) rotate(16.25)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.68,
    y: 343.56,
    width: 3.11,
    height: 3.11,
    transform: "translate(104.75 -43.37) rotate(16.25)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.43,
    y: 343.97,
    width: 0.59,
    height: 2,
    transform: "translate(104.69 -43.23) rotate(16.25)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.45,
    y: 344.27,
    width: 0.59,
    height: 2,
    transform: "translate(104.88 -43.52) rotate(16.26)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.57,
    y: 367.73,
    width: 3.11,
    height: 3.11,
    transform: "translate(114.83 -65.6) rotate(16.25)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.07,
    y: 368.69,
    width: 0.61,
    height: 0.76,
    transform: "translate(114.75 -65.4) rotate(16.25)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.08 370.17 286.33 369.44 286.54 368.72 287.56 368.51 287.08 370.17",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--u5Zjqx--inject-94"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.92,368.92l.17-.1a1,1,0,0,1-.4,1.37l-.1-.17a.82.82,0,0,0,.33-1.1Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.5,369.84l-.1-.17a.39.39,0,0,0,.2-.25.37.37,0,0,0,0-.31l.17-.1A.6.6,0,0,1,287.5,369.84Z",
    style: {
      fill: "#a6a6a6"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 289.14,
    y: 368.77,
    width: 3.11,
    height: 3.11,
    transform: "translate(115.26 -66.56) rotate(16.25)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.77,
    y: 369.17,
    width: 1.29,
    height: 1.29,
    transform: "translate(115.1 -66.5) rotate(16.25)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.33,
    y: 370.26,
    width: 1.29,
    height: 1.29,
    transform: "translate(115.42 -66.61) rotate(16.25)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.87,350.26a1.75,1.75,0,0,0-.05.75l-14.57-4.25.41-1.41,14.58,4.25A1.59,1.59,0,0,0,221.87,350.26Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.07,351.19a1.63,1.63,0,0,1-.36.66,1.68,1.68,0,0,1-2.89-.84,1.75,1.75,0,0,1,.05-.75,1.59,1.59,0,0,1,.37-.66,1.65,1.65,0,0,1,1.69-.48,1.67,1.67,0,0,1,1.18,1.32A1.74,1.74,0,0,1,225.07,351.19Z",
    style: {
      fill: "#a6a6a6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-94"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M474.76,415c.63-1.77,33.11-42.89,35.29-43.65.24-.1,14.17,10.25,14.17,10.25.56.79,27.55-4.32,27.55-4.32l-.41,32.41-48.91-2.06s-6.69,3.75-12.81,6.79h0a72.74,72.74,0,0,1-8,3.69C479.13,418.71,474.12,416.78,474.76,415Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.59,418.13a70,70,0,0,0,8-3.69h0c6.11-3,12.8-6.79,12.8-6.79l10.89.46L531,381c-3.75.59-6.55.92-6.73.67,0,0-13.92-10.35-14.17-10.25-2.18.76-34.66,41.88-35.29,43.65S479.13,418.71,481.59,418.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.47,415.07c.66-1.82,33.28-42.9,35.52-43.69.84-.3,7.67,4.12,14.23,10.24l-21.07,26.47s-19.13,9.63-21.67,10.22S473.81,416.89,474.47,415.07Z",
    style: {
      fill: "#7A679C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.58,415.78c5.64-6.75,27.74-34.52,32.8-41.62,0-.06,0-.09,0,0-5.74,6.58-27.61,34.52-32.87,41.58C476.36,415.84,476.46,415.93,476.58,415.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.06,416.84a7.1,7.1,0,0,0,1.59-5.46,6.89,6.89,0,0,0-2.46-4.46s-.1.05-.06.09a8.16,8.16,0,0,1,.84,9.76A.06.06,0,0,0,485.06,416.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.75,409.7c2.22-2.73,3.79-6.7,2.89-10.2,0-.13-.22-.08-.25,0a49,49,0,0,1-3,10A.22.22,0,0,0,500.75,409.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.23,411.17c2.22-2.73,3.79-6.7,2.89-10.2,0-.14-.22-.08-.25,0a48.38,48.38,0,0,1-3,9.95A.22.22,0,0,0,498.23,411.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.71,412.64c2.22-2.73,3.79-6.7,2.89-10.2,0-.14-.22-.08-.25,0a48.38,48.38,0,0,1-3,9.95A.22.22,0,0,0,495.71,412.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.19,414.11c2.22-2.73,3.79-6.7,2.89-10.2,0-.14-.22-.09-.25,0a48.38,48.38,0,0,1-3,9.95A.22.22,0,0,0,493.19,414.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.53,381.11c2.45-3.1-2.37-6.91-4.82-3.81S512.08,384.21,514.53,381.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.74,418.52c2.26-.48,2.53-3.13,2-4.95a18.49,18.49,0,0,0-5.06-8.1.1.1,0,0,0-.15,0c-.24-.09-.6,0-.62.32-.2,3-.79,6.27-.05,9.28C502.3,416.85,503.59,419,505.74,418.52Zm-3.18-8c.06-1.5.2-3,.21-4.49,1,1.59,2,3.12,2.85,4.8a20.09,20.09,0,0,1,1.06,2.48c.43,1.32.59,5.86-2.63,3.75C502.28,415.87,502.49,412.27,502.56,410.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.1,397.81c-2.27,2.11-3.55,5.13-5.06,7.77a.43.43,0,0,0,.34.61.09.09,0,0,0,.11.1,18.33,18.33,0,0,0,8.68-4c1.44-1.22,2.68-3.59,1.05-5.23S508.43,396.58,507.1,397.81Zm2.89-.42c3.85,0,1.22,3.71.13,4.58a21.37,21.37,0,0,1-2.25,1.49,55.22,55.22,0,0,1-5,2.43c.82-1.25,1.52-2.57,2.3-3.85C506.07,400.51,507.87,397.38,510,397.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.36,369.59l22.06-1.74s31.86-9.24,50.27-4.4c21.11,5.54,24.09,30.2,2.63,40.09-21.24,9.78-114.71,6.17-114.71,6.17l20-29.67s30.77-7.23,57.71-5.77l-38.14,4.4Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.58,375.86c3.28-.54,6.6-.8,9.91-1.11s6.69-.55,10-.76a200.55,200.55,0,0,1,20.07-.31l1.88.1c.13,0,.27-.06.41-.09.32-.07.64-.15,1-.2.6-.11,1.21-.18,1.82-.26,1.27-.17,2.54-.28,3.81-.49.07,0,.1.11,0,.12-1.27.26-2.52.6-3.79.85l-1.1.21c2.45.18,4.89.42,7.33.69.08,0,.08.13,0,.12-3.32-.26-6.68-.36-10-.37s-6.63,0-9.94.11c-6.7.24-13.39.71-20.07,1.26-3.75.32-7.51.7-11.27.78A.33.33,0,0,1,553.58,375.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.18,409c1.24-1.89,2.3-3.91,3.43-5.86L530,397.3c2.28-3.9,10.45-17,11.25-17.92.05-.06.15,0,.12.08-.39,1-5.5,9.7-6.67,11.64-2.35,3.87-4.82,7.66-7.25,11.48-.69,1.09-1.41,2.17-2.11,3.25s-1.45,2.15-2.1,3.27C523.24,409.17,523.14,409.1,523.18,409Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.92,421c-.54-1.8-31-44.41-33.18-45.27-.24-.11-14.64,9.57-14.64,9.57-.6.76-27.31-5.63-27.31-5.63l-1.13,32.4,49,.26s6.51,4.06,12.47,7.38h0a74.69,74.69,0,0,0,7.85,4.06C628.38,424.48,633.48,422.79,632.92,421Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626,423.78a68.8,68.8,0,0,1-7.85-4.07s0,0,0,0c-6-3.32-12.46-7.39-12.46-7.39l-10.9-.05-16.32-28c3.73.76,6.51,1.23,6.7,1,0,0,14.39-9.68,14.64-9.57,2.14.86,32.64,43.47,33.18,45.27S628.38,424.48,626,423.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.21,421.06c-.57-1.84-31.22-44.43-33.41-45.32-.83-.34-7.86,3.75-14.7,9.56l19.79,27.43s18.65,10.52,21.16,11.24S633.78,422.91,633.21,421.06Z",
    style: {
      fill: "#7A679C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.07,421.68c-5.32-7-26.08-35.8-30.8-43.14,0-.06,0-.08.05,0,5.41,6.84,25.94,35.79,30.86,43.08C631.29,421.75,631.18,421.82,631.07,421.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.55,422.33a7,7,0,0,1-1.33-5.53,6.8,6.8,0,0,1,2.66-4.33s.1,0,.06.08a8.17,8.17,0,0,0-1.3,9.72C622.67,422.33,622.59,422.39,622.55,422.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.22,414.45c-2.1-2.82-3.48-6.86-2.42-10.32,0-.13.23-.07.25,0a48.86,48.86,0,0,0,2.55,10.08A.22.22,0,0,1,607.22,414.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.66,416c-2.09-2.83-3.47-6.87-2.41-10.32,0-.14.23-.08.25,0a48.86,48.86,0,0,0,2.55,10.08A.22.22,0,0,1,609.66,416Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.11,417.63c-2.1-2.83-3.47-6.87-2.41-10.33,0-.13.23-.07.25.05a48,48,0,0,0,2.55,10.07A.22.22,0,0,1,612.11,417.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.56,419.22c-2.1-2.83-3.47-6.87-2.41-10.33,0-.13.23-.07.24,0A49.5,49.5,0,0,0,614.94,419,.22.22,0,0,1,614.56,419.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.8,385.24c-2.3-3.21,2.69-6.79,5-3.57S597.1,388.46,594.8,385.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.84,419.79c.88-3,.44-6.23.38-9.27a.42.42,0,0,0-.6-.35c0-.05-.09-.08-.14,0A18.49,18.49,0,0,0,600,418c-.61,1.79-.47,4.46,1.77,5S605.32,421.52,605.84,419.79Zm-2.27,1.83c-3.32,2-3-2.57-2.45-3.87a20.16,20.16,0,0,1,1.18-2.43,53.35,53.35,0,0,1,3.07-4.65c-.06,1.49,0,3,0,4.48C605.35,416.94,605.39,420.55,603.57,421.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.35,401.3c-1.7,1.57-.57,4,.8,5.28a18.52,18.52,0,0,0,8.49,4.39.09.09,0,0,0,.11-.1.43.43,0,0,0,.37-.59c-1.38-2.71-2.52-5.79-4.69-8C600.16,401,598,399.82,596.35,401.3Zm6.83,5.29c.71,1.32,1.36,2.67,2.12,4a54.17,54.17,0,0,1-4.91-2.67,19.79,19.79,0,0,1-2.17-1.59c-1.05-.92-3.5-4.74.34-4.57C600.68,401.82,602.34,405,603.18,406.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.57,369.7l-22-.59s-22.68-11.65-41.3-7.69c-21.35,4.54-24.77,31.11-9.16,40.95,19.77,12.47,109.22,12.53,109.22,12.53l-18.45-33.27s-29.56-7-56.54-6.85L556.27,381Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.15,383.78a.85.85,0,0,1,0-.17l0-.14c0-.1-.05-.21-.07-.31a6.18,6.18,0,0,0-.21-.65c-.08-.22-.16-.42-.26-.63a4.3,4.3,0,0,0-.34-.59s0,0-.05,0l0,0,0,0-.05,0c-3.26-.69-25.38-4.46-28.68-4.92s-6.65-.87-10-1.24a197.22,197.22,0,0,0-20-1.25h-1.88l-.41-.11c-.32-.08-.63-.17-1-.24-.6-.13-1.2-.24-1.81-.35-1.26-.22-2.52-.39-3.77-.66-.08,0-.11.1,0,.12,1.26.31,2.49.71,3.75,1l1.09.26q-3.67.1-7.36.35c-.07,0-.08.12,0,.12,3.33-.11,6.69,0,10,.1s6.62.3,9.92.58c6.68.56,13.35,1.34,20,2.21,3.73.49,26.29,4.4,30,4.66H575a1.17,1.17,0,0,0,.1.26c.09.21.19.41.3.61a6.55,6.55,0,0,0,.32.58l.17.28.09.13a.78.78,0,0,1,.1.15C576.06,383.91,576.19,383.86,576.15,383.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.46,412.72c-1.15-1.94-2.12-4-3.16-6s-2.09-4-3.14-6c-2.09-4-9.63-17.48-10.39-18.43,0-.06-.15,0-.13.07.35,1,5,10,6.12,11.95,2.17,4,4.45,7.88,6.69,11.81.64,1.12,1.31,2.23,2,3.35s1.35,2.21,1.94,3.36C586.39,412.86,586.5,412.79,586.46,412.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.09,368.73c.82.87,53,2.07,53.27,1.74.72-.9-6-34-11.47-46.68-7-16.23-10.93-17.69-13.27-18.65a18.49,18.49,0,0,0-9.76-.4c-1.49.61-8,7.88-9.91,13.75C539.05,330.29,533.38,368,534.09,368.73Z",
    style: {
      fill: "#7A679C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.88,325.83a7.65,7.65,0,0,0-.68,2,8,8,0,0,0-.13,2.14,7.34,7.34,0,0,0,.69-2A8,8,0,0,0,555.88,325.83ZM563.22,360a7.56,7.56,0,0,0-.67,2,7.67,7.67,0,0,0-.14,2.15,7.77,7.77,0,0,0,.68-2A7.67,7.67,0,0,0,563.22,360Zm-19.91-15.34a7.42,7.42,0,0,0-.68,2,7.67,7.67,0,0,0-.13,2.14,7.59,7.59,0,0,0,.68-2A8.06,8.06,0,0,0,543.31,344.62ZM578,341.83a7.6,7.6,0,0,0-.68,2.05,7.94,7.94,0,0,0-.13,2.13,7.17,7.17,0,0,0,.69-2A8.06,8.06,0,0,0,578,341.83ZM561.6,307.59a7.69,7.69,0,0,0-2.15-.14,7.65,7.65,0,0,0,2,.68,6.94,6.94,0,0,0,2.14.13A7.68,7.68,0,0,0,561.6,307.59ZM578,329.38a8.34,8.34,0,0,0-1.74-.54,8,8,0,0,0-2.14-.13,7.65,7.65,0,0,0,2,.68,7.43,7.43,0,0,0,1.89.14,1,1,0,0,0,.25,0Zm-36-7.65c0,.17-.09.34-.14.52a6.88,6.88,0,0,0,1.93.1A6.92,6.92,0,0,0,542,321.73Zm7.56,46.19a7.69,7.69,0,0,0-2.15-.13,7.42,7.42,0,0,0,2,.68,7.64,7.64,0,0,0,2.14.13A7.59,7.59,0,0,0,549.56,367.92Zm1.28-28.72a7.69,7.69,0,0,0-2.15-.12,7.77,7.77,0,0,0,2,.68,8.06,8.06,0,0,0,2.14.13A7.28,7.28,0,0,0,550.84,339.2Zm36.39,29a7.41,7.41,0,0,0-.94,0,6.09,6.09,0,0,0,1,.42Zm-17.54-15.81a7.27,7.27,0,0,0-2.14-.14,7.71,7.71,0,0,0,2,.68,7.35,7.35,0,0,0,2.15.13A7.29,7.29,0,0,0,569.69,352.39Zm-18.21-36.78a7.71,7.71,0,0,0-1.43-1.6,8.21,8.21,0,0,0,1,1.92,7.76,7.76,0,0,0,1.43,1.61A8.09,8.09,0,0,0,551.48,315.61Zm-.37,41.11a7.51,7.51,0,0,0-1.43-1.61,7.37,7.37,0,0,0,1,1.92,7.66,7.66,0,0,0,1.41,1.61A7.32,7.32,0,0,0,551.11,356.72ZM572,368a7.66,7.66,0,0,0-1.41-1.61,7.35,7.35,0,0,0,1,1.92,7,7,0,0,0,1.42,1.61A7.37,7.37,0,0,0,572,368Zm-5-32.55a7.43,7.43,0,0,0-1.42-1.61,8,8,0,0,0,1,1.92,7.25,7.25,0,0,0,1.43,1.61A8.05,8.05,0,0,0,567,335.49Zm-24.32-4.95A7.92,7.92,0,0,0,541,332a7.28,7.28,0,0,0,1.91-1,7.06,7.06,0,0,0,1.62-1.43A8.12,8.12,0,0,0,542.63,330.54Zm-4,30.14a7.63,7.63,0,0,0-1.6,1.42,7.5,7.5,0,0,0,1.92-1,7.71,7.71,0,0,0,1.61-1.42A7.11,7.11,0,0,0,538.63,360.68Zm20.83-14.63a7.47,7.47,0,0,0-1.62,1.41,8.15,8.15,0,0,0,3.53-2.38A7,7,0,0,0,559.46,346.05Zm20,13.77a7.25,7.25,0,0,0-1.61,1.43,7.63,7.63,0,0,0,1.91-1,7.51,7.51,0,0,0,1.62-1.42A7.5,7.5,0,0,0,579.49,359.82Zm-14.11-40.71a7.25,7.25,0,0,0-1.61,1.43,8.56,8.56,0,0,0,3.53-2.38A7.32,7.32,0,0,0,565.38,319.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.27,309.53c22.5,16.91,42,40.38,40.09,47.81-2,7.86-17.53,16.65-31.27,18.45-2.81.36-11.51-20.27-8.63-21.21,2.24-.74,12.45-3.65,13.67-5.05.85-1-15-23.26-20.15-34.9C559.59,302.45,565.24,305,571.27,309.53Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.26,354s-8.59.86-14.18,1.69c-3.12.46-8.39,1.73-10.53,3.12-3.19,2.08-15.22,12.8-12.69,15.77,2.3,2.69,5.76-1.57,5.76-1.57s-4.22,4.3-1.12,6.27,7.1-4,7.1-4-4.81,4.26-1.3,6c3.05,1.55,8.37-4.85,8.37-4.85s-5.53,3.92-2.57,5.81c3.28,2.1,12.47-6.5,12.47-6.5,7.35.83,11.88.32,17.06-1.13C586.58,374.34,577.26,354,577.26,354Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.31,376.67c.33-.46.67-.91,1-1.36a27.08,27.08,0,0,1,2.06-2.58c.73-.79,1.49-1.54,2.28-2.26s1.75-1.46,2.56-2.25c.06-.07.15,0,.08.09a29.49,29.49,0,0,0-2.29,2.45l-2.18,2.47c-.7.81-1.46,1.56-2.18,2.35-.37.39-.71.8-1.06,1.21a8.41,8.41,0,0,1-1,1.14s-.08,0-.07-.06A7.43,7.43,0,0,1,550.31,376.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.76,373.87a43.46,43.46,0,0,1,3.71-4.86,30.55,30.55,0,0,1,4.53-4.13c.06-.05.13,0,.09.09-1.37,1.53-2.76,3-4.15,4.54-.68.74-3.66,4.18-4,4.5C544.84,374.09,544.72,374,544.76,373.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.45,379.43a43.64,43.64,0,0,1,3.57-4.52,39.89,39.89,0,0,1,4.61-3.66c.06,0,.14.05.08.1-1.44,1.33-2.89,2.63-4.27,4-.67.68-3.18,3.56-3.87,4.15A.08.08,0,0,1,555.45,379.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.29,330.38l-17.14,11.11s-12.71-19.68-16-29,.55-9.35,9.54-2.59S596.29,330.38,596.29,330.38Z",
    style: {
      fill: "#7A679C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.92,318.78c.08.15.15.3.23.46a6.52,6.52,0,0,0,1.15-1.08A5.94,5.94,0,0,0,565.92,318.78Zm19.62,12.57a7.25,7.25,0,0,0-1.61,1.43,8.24,8.24,0,0,0,1.92-1,7,7,0,0,0,1.6-1.42A7.78,7.78,0,0,0,585.54,331.35Zm-.21-8.21a7.66,7.66,0,0,0-1.42-1.6,7.82,7.82,0,0,0,1,1.92,8.38,8.38,0,0,0,1.43,1.61A7.41,7.41,0,0,0,585.33,323.14Zm-9.1,5.7a8,8,0,0,0-2.14-.13,8.25,8.25,0,0,0,4.18.81A7.65,7.65,0,0,0,576.23,328.84Zm18.73.31a6.49,6.49,0,0,0-.76,0,6.25,6.25,0,0,0,1.34.51C595.38,329.52,595.18,329.34,595,329.15Zm-33-21.47a5,5,0,0,0,0,.53,5.7,5.7,0,0,0,1.6.05A6.5,6.5,0,0,0,562,307.68ZM576.52,314a7.31,7.31,0,0,0-.68,2,7.6,7.6,0,0,0-.13,2.14,7.65,7.65,0,0,0,.68-2A8,8,0,0,0,576.52,314Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.4,327.92a139.54,139.54,0,0,1-14.27,9.63c-.06,0-.12-.06-.06-.1,1.3-.79,8.29-5.93,14.26-9.64C592.4,327.77,592.46,327.87,592.4,327.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.25,340.73a11.69,11.69,0,0,0-1,.54c-1.9-3.29-4-6.62-5.89-9.89l-2.85-4.81c-1-1.66-1.88-3.41-3-5a0,0,0,0,0-.08,0,52,52,0,0,0,2.34,4.66c-.17-.23-.34-.48-.53-.7-.42-.5-.84-1-1.22-1.54-.06-.08-.19,0-.14.08.37.51.69,1,1,1.57s.68,1,1,1.57.73,1,1.11,1.43a2.09,2.09,0,0,0,.14.17c.52,1,1,1.92,1.57,2.86,1.91,3.31,6.24,10,6.3,10a10.25,10.25,0,0,0,1.24-.83S580.3,340.72,580.25,340.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.06,310.32C525,320.1,508,331.92,504.91,340c-2,5.08.7,14.18,2.83,19.65,1,2.66,26.12-8.18,24-10.36-5.28-5.41-6.14-7.6-5.61-8.72.35-.71,20-18.39,25.53-26.3C559.28,303.23,551,306,543.06,310.32Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.67,373.9c-2.36,1.37-5.26-4.74-5.26-4.74a5.07,5.07,0,0,1-1.36,3.15c-1.49,1.45-4.42-.26-4.42-.26a6.24,6.24,0,0,1-2,3.1c-1.57,1.24-4.76-.06-4.76-.06a5.49,5.49,0,0,1-3.44,1.64c-3.5.16-6.55-4.24-8.52-7s-4.94-12.49-5.7-14.29L524,342.65s12.36,9.94,14.21,13.54C539.74,359.21,545.29,371.79,541.67,373.9Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.45,369.07a45.58,45.58,0,0,0-4.36-10.27c0-.08-.15,0-.11.06,1.75,3.22,2.68,7,4.3,10.27A.09.09,0,0,0,536.45,369.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.82,371.83a9.47,9.47,0,0,0-1.14-2.27c-.46-.77-.93-1.54-1.41-2.29-1-1.52-2-3-3-4.48,0-.07-.15,0-.11.06q1.46,2.26,2.81,4.59c.45.78.89,1.56,1.33,2.35a11.07,11.07,0,0,0,1.34,2.15A.12.12,0,0,0,530.82,371.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.87,375a6.89,6.89,0,0,0-1.14-2c-.46-.68-.91-1.37-1.36-2.05-.89-1.38-1.79-2.75-2.64-4.16,0-.07-.15,0-.11.06.85,1.44,1.69,2.88,2.56,4.3.42.7.85,1.4,1.29,2.09a6.38,6.38,0,0,0,1.33,1.79S523.88,375.06,523.87,375Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.92,325l13.58,12.89s17.33-15.86,22.28-24.42,1.17-9.29-8.9-4.3S516.92,325,516.92,325Z",
    style: {
      fill: "#7A679C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.87,312.43a7.38,7.38,0,0,0-1.6,1.42,7.31,7.31,0,0,0,1.91-1,7.19,7.19,0,0,0,1.61-1.41A7.2,7.2,0,0,0,540.87,312.43Zm-8.67,19a7.41,7.41,0,0,0-1.42-1.6,8.14,8.14,0,0,0,1,1.91,6.81,6.81,0,0,0,1.43,1.61A8.24,8.24,0,0,0,532.2,331.43ZM550.05,314a8.21,8.21,0,0,0,1,1.92l.07.09c.12-.16.24-.33.34-.49A7.55,7.55,0,0,0,550.05,314Zm-8.3,7.66a7.67,7.67,0,0,0-2.15-.13,7.72,7.72,0,0,0,2,.68,7.62,7.62,0,0,0,2.14.13A7.65,7.65,0,0,0,541.75,321.67Zm-19.56,3.88a7.71,7.71,0,0,0-2.15-.12,7.77,7.77,0,0,0,2,.68,8.45,8.45,0,0,0,2.14.13A7.28,7.28,0,0,0,522.19,325.55Zm9.47-6.13a8.25,8.25,0,0,0-.81,4.18,7.65,7.65,0,0,0,.68-2A8,8,0,0,0,531.66,319.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.22,334.39a132,132,0,0,1-12-11.56c-.06-.05,0-.12.08-.07,1,1.07,7.3,6.65,12,11.55C533.37,334.37,533.28,334.44,533.22,334.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.51,319c-.65,1.44-1.29,2.88-1.83,4.37,0-.1,0-.2,0-.3a17.52,17.52,0,0,1,.36-2.7.08.08,0,0,0-.15,0c-.19.89-.35,1.8-.48,2.7-.07.44-.1.88-.13,1.32,0,0,0,.1,0,.15s0,0,0,.06c-.61,2-1,4-1.52,6a.08.08,0,0,0,.15,0c.52-2,1.27-3.85,1.93-5.77s1.18-3.86,1.81-5.77A.07.07,0,0,0,543.51,319Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.65,313.87c3,.58,7.89-4.16,9.74-7.91a61.38,61.38,0,0,0-.82-6.12c-.26-2-.51-4.15-.6-6.16,0-.42-12.51,3.59-12.51,3.59A32.25,32.25,0,0,1,552,305a4.51,4.51,0,0,1-.06.83s0,.08,0,.13C551.75,307.51,551.76,313.31,554.65,313.87Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.2,293.76c-.45,3.43-2.22,11.75-9,12.18a7.85,7.85,0,0,1-1.29,0,.31.31,0,0,1,0-.14,5.61,5.61,0,0,0,0-.83,32.25,32.25,0,0,0-1.55-7.69S559.48,294.38,562.2,293.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561,277.05c2.41,4,3.24,17.16.84,20.74-3.48,5.17-10.73,7.39-15.52,2.85-4.65-4.39-5.42-21.54-2.6-24.94C547.89,270.68,557.45,271.11,561,277.05Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.56,289.27s.08,0,.08.07c0,.89.22,1.9,1,2.14,0,0,0,0,0,0C551.69,291.45,551.45,290.11,551.56,289.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.29,288.29c1.42-.21,1.72,2.64.41,2.83S551.1,288.46,552.29,288.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.63,289.82s-.06.05-.06.09c.12.87.12,1.9-.65,2.28,0,0,0,.06,0,.05C546.89,292,546.89,290.63,546.63,289.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.74,289c-1.43,0-1.23,2.91.09,2.86S546.94,289,545.74,289Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.36,285.89a9.17,9.17,0,0,1-1.17-.06,2,2,0,0,1-1.19-.29.61.61,0,0,1-.11-.73,1.51,1.51,0,0,1,1.41-.58,2.26,2.26,0,0,1,1.49.56A.65.65,0,0,1,553.36,285.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.22,287.05c.38-.11.72-.27,1.1-.42a1.86,1.86,0,0,0,1-.64.61.61,0,0,0-.12-.73,1.51,1.51,0,0,0-1.51-.12,2.19,2.19,0,0,0-1.25,1A.65.65,0,0,0,544.22,287.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.92,297.3c-.19.23-.37.54-.69.6a2.28,2.28,0,0,1-1-.12,0,0,0,0,0,0,.05,1.22,1.22,0,0,0,1.17.36.93.93,0,0,0,.61-.86C554,297.28,553.94,297.27,553.92,297.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.71,294.76a3,3,0,0,1-1.87,1.55,3.86,3.86,0,0,1-1.07.17h-.41a.22.22,0,0,1-.19-.18h0a.28.28,0,0,1,0-.09h0v-.07c-.09-.68-.14-1.72-.14-1.72-.23.15-1.44.86-1.46.5a45.76,45.76,0,0,1,.19-9.21c0-.1.17-.1.17,0,.24,2.84,0,5.7.19,8.55a5.25,5.25,0,0,1,1.37-.58c.1,0,0,2,.12,2.31a.08.08,0,0,0,0,0,4.16,4.16,0,0,0,3-1.3C552.67,294.63,552.75,294.68,552.71,294.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.13,296.09a3.54,3.54,0,0,0,1.55,1,1.57,1.57,0,0,0,1,0c.68-.26.63-.91.44-1.45a3.86,3.86,0,0,0-.4-.81A4.68,4.68,0,0,1,550.13,296.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.68,297a1.57,1.57,0,0,0,1,0c.68-.26.63-.91.44-1.45A1.66,1.66,0,0,0,551.68,297Z",
    style: {
      fill: "#ff98b9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.2,288.13c-3.25.72-5.22-5-5.22-5s-5.79.35-7.55-3.67c0,0-4.53,4.58-9,4s-4.69-5.48-4.46-6.59,3,.24,3,.24-.34-2.73.31-3.16,1.79,1,1.79,1a35.38,35.38,0,0,1,9.86-4c4.9-1,8.42,3.4,8.42,3.4s2.73,0,4,1.6S565.27,287.67,563.2,288.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.32,278.6a7.13,7.13,0,0,0,1.07,2.38,4.62,4.62,0,0,0,2,1.56,6.88,6.88,0,0,0,2.52.42c.43,0,.87-.07,1.31-.11l1.31-.23c-.42.16-.84.29-1.27.44s-.88.17-1.33.23a6.14,6.14,0,0,1-2.71-.35,4.45,4.45,0,0,1-2.07-1.78A5.38,5.38,0,0,1,550.32,278.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.46,275a8.28,8.28,0,0,0-2.74-3.23,6.63,6.63,0,0,0-4-1.11,9.45,9.45,0,0,0-1.06.08l-1,.22c-.69.18-1.35.45-2,.69s-1.31.6-1.93.95-1.24.74-1.88,1.1c.58-.44,1.18-.85,1.77-1.28s1.27-.71,1.9-1.07a11.17,11.17,0,0,1,4.24-1.12,6.74,6.74,0,0,1,4.19,1.27A7.41,7.41,0,0,1,560.46,275Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.87,288s1.93-4.73,4-4.13,1.29,7-.71,8.31a2.27,2.27,0,0,1-3.23-.52Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.61,285.66a0,0,0,0,1,0,0,5.72,5.72,0,0,0-2.09,4.16,1.25,1.25,0,0,1,1.75-.75s0,.09,0,.09a1.4,1.4,0,0,0-1.39.82,7.07,7.07,0,0,0-.44,1.37c0,.15-.3.14-.28,0v0C561.67,289.39,562.56,286.33,564.61,285.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566,306.78a60,60,0,0,1-4,5.23,9.68,9.68,0,0,1-5.14,3.3c-2,.36-4,.12-5-2.25a14.78,14.78,0,0,1-.71-6.4.08.08,0,1,0-.15,0c-.17,3.24-.22,8.22,2.78,9.07,3.36.95,6.4-1,8.48-3.44a30,30,0,0,0,3.78-5.46A0,0,0,0,0,566,306.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 514.41,
    y: 380.74,
    width: 57.6,
    height: 2.58,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "559.69 380.74 561.66 383.32 514.41 383.32 514.41 380.74 559.69 380.74",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "557.22 383.32 501.08 383.32 496.41 345.19 552.55 345.19 557.22 383.32",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.23,364.25a3.34,3.34,0,0,1-3.35,3.42,3.49,3.49,0,0,1-3.48-3.42,3.35,3.35,0,0,1,3.36-3.41A3.49,3.49,0,0,1,530.23,364.25Z",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/Website.070d8d9baa42d37634078053151af7c3.svg";
export { ForwardRef as ReactComponent };